import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DepartmentSpotlightListComponent } from './department-spotlight-list/department-spotlight-list.component';
import { DepartmentSpotlightCreateComponent } from './department-spotlight-create/department-spotlight-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: DepartmentSpotlightListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: DepartmentSpotlightCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'department-spotlight-create/:id',
        component: DepartmentSpotlightCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DepartmentSpotlightRoutingModule { }
